"use client";

import { useEffect } from "react";
import { captureAttribution } from "../lib/attribution";

/**
 * Mounts in the root layout. On every page-load it calls captureAttribution()
 * which is idempotent within the 30-day window — first-touch utm_* + gclid +
 * fbclid + referrer get pinned to localStorage and survive across pages.
 *
 * Renders nothing — pure side effect.
 */
export default function AttributionCapture() {
  useEffect(() => {
    captureAttribution();
  }, []);
  return null;
}
